<template>
  <DrawerPage drawerName="adminCouleur">
    <template #content>
      <div class="flex flex-col mx-8 mt-8">
        <AnimatedList>
          <IdCardCouleur v-for="couleur in couleurStore.couleurs" :couleur="couleur" :key="couleur.uuid" />
        </AnimatedList>

        <ModalCreationCouleurComponent :isVisible="couleurStore.showModalCreation"/>
      </div>
    </template>

    <template #drawer>
      <CreationCouleurForm isVertical class="mx-16 md:mx-8" />
    </template>
  </DrawerPage>
</template>

<script setup>

import {CouleurStore} from "@/stores/CouleurStore";
import IdCardCouleur from "@/components/organismes/idCardCouleur.vue";
import {enumeration} from "../../Enumeration";
import {router} from "@/routeur";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {NotificationStores} from "@/stores/NotificationStores";
import ModalCreationCouleurComponent from "@/components/organismes/ModalCreationCouleurComponent.vue";
import {t} from "@/utils/Traduction";
import AnimatedList from "@/components/molecules/AnimatedList.vue";
import DrawerPage from "@/components/organismes/DrawerPage.vue";
import CreationCouleurForm from "@/components/organismes/CreationCouleurForm.vue";

const couleurStore = CouleurStore();
const utilisateurStore = UtilisateurStores();
const notificationStores = NotificationStores();

if(utilisateurStore.role !== enumeration.role.ADMIN) {
  utilisateurStore.logout(false);
  notificationStores.addNotification(t('youNeedToBeAdminToAccessThisPage'), 'error');
  router.push({ path: "/" });
}

couleurStore.loadCouleurs();

</script>

<style scoped>

</style>